// Image Uploading
export const PS_URL =
  process.env.STAGE_ENV === 'prod'
    ? 'https://s3.amazonaws.com/painscale-prod/cms/imgs/'
    : 'https://s3.amazonaws.com/painscale-stage/cms/imgs/'

// Contents
export const FORM_TYPES = [
  'card',
  'listicle',
  'article',
  'article-cta',
  'video',
  'freeform',
]
export const contentTypeOptions = [
  { value: 'card', text: 'Card' },
  { value: 'listicle', text: 'Listicle' },
  { value: 'infographic', text: 'Infographic' },
  { value: 'article', text: 'Article' },
  { value: 'video', text: 'Video' },
  { value: 'news', text: 'News' },
]

export const CONTENT_CATEGORIES = [
  'Pain',
  'Living with Chronic Pain',
  'Treatments',
  'Wellness',
  'Patient & Physican Feedback',
  'Painscale App',
  'Opioid Epidemic',
].map(category => ({ text: category, value: category }))

// Featured
export const MAX_FEATURED = 20
export const MIN_FEATURED = 5

// Tags
export const TAG_CATEGORY_OPTIONS = [
  { value: 'conditions', label: 'Conditions' },
  { value: 'treatments', label: 'Treatments' },
  { value: 'activities', label: 'Activities' },
  { value: 'wellness', label: 'Wellness' },
  { value: 'other', label: 'Other' },
]

// Messages + Welcomes
export const MAX_CTA_LENGTH = 16

export const MESSAGE_DESTINATION_OPTIONS = [
  { value: 'no_cta', label: 'No CTA', onlyWelcome: true },
  {
    value: 'learn',
    label: 'Learn',
    coachmark: 'View Now',
    onlyMessage: true,
  },
  { value: 'painLog', label: 'Log Pain', coachmark: 'Log Now' },
  {
    value: 'insight_community',
    label: 'Insights: Community',
    coachmark: 'View Insights',
  },
  {
    value: 'insight_personal',
    label: 'Insights: Personal',
    coachmark: 'View Insights',
  },
  { value: 'history', label: 'History', coachmark: 'View History' },
  {
    value: 'recommended',
    label: 'Learn: Recommended',
    coachmark: 'View Now',
  },
  { value: 'register', label: 'Register', coachmark: 'Sign Up!' },
  {
    value: 'bookmarks',
    label: 'Learn: Bookmarks',
    coachmark: 'View Now',
  },
  { value: 'poll', label: 'Poll', coachmark: 'Join Poll', param: 'id' },
  {
    value: 'profile',
    label: 'Profile',
    coachmark: 'Complete Profile',
    param: 'select',
  },
  {
    value: 'profile_insurance',
    label: 'Profile: Add Insurance',
    coachmark: 'Add Insurance',
  },
  {
    value: 'profile_zip',
    label: 'Profile: Add Zipcode',
    coachmark: 'Add Zipcode',
    onlyWelcome: true,
  },
  {
    value: 'profile_phone',
    label: 'Profile: Add Phone',
    coachmark: 'Add Phone',
    onlyWelcome: true,
  },
  {
    value: 'shareReport',
    label: 'Share: Report',
    coachmark: 'Share Report',
  },
  {
    value: 'shareApp',
    label: 'Share: App',
    coachmark: 'Tell Friends About PainScale',
    onlyMessage: true,
  },
  {
    value: 'giveFeedback',
    label: 'Share: Feedback',
    coachmark: 'Give Feedback',
    onlyMessage: true,
  },
  {
    value: 'rateApp',
    label: 'Rate App',
    coachmark: 'Review PainScale',
    onlyMessage: true,
  },
  {
    value: 'facebook',
    label: 'PainScale on Facebook',
    coachmark: 'PainScale On Facebook',
    onlyMessage: true,
  },
  {
    value: 'featured',
    label: 'Learn: Featured',
    coachmark: 'View Now',
    onlyMessage: true,
  },
  {
    value: 'scsQualify',
    label: 'SCS Qualify',
    coachmark: 'Learn More',
  },
  {
    value: 'updateApp',
    label: 'Update App',
    coachmark: 'Update App',
    onlyMessage: true,
  },
  {
    value: 'event',
    label: 'View Event',
    onlyMessage: true,
    param: 'id',
  },
  {
    value: 'article',
    label: 'View Article',
    onlyMessage: true,
    param: 'id',
  },
  { value: 'enableWeather', label: 'Enable Weather', onlyMessage: true },
  { value: 'enablePush', label: 'Enable Push', onlyMessage: true },
  { value: 'enableHealthKit', label: 'Enable HealthKit', onlyMessage: true },
  { value: 'mealLog', label: 'Food Journal', onlyMessage: true },
  { value: 'search', label: 'Search', onlyMessage: true, param: 'text' },
]

export const MESSAGE_LABEL_OPTIONS = [
  { value: 'Reminder', label: 'Reminder' },
  { value: 'Tip', label: 'Tip' },
  { value: 'Helpful Hint', label: 'Helpful Hint' },
  { value: 'custom', label: 'Custom' },
]

export const MESSAGE_TYPES = [
  { value: 'reminder', label: 'Message with CTA' },
  { value: 'info', label: 'Message no CTA' },
  { value: 'content', label: 'PainScale Content' },
  { value: 'external', label: 'Content from the Web' },
]

// Events
export const EVENT_TYPES = [
  { value: 'in_person', label: 'In Person' },
  { value: 'global', label: 'Webinar/Global' },
]

export const TIMEZONES = [
  { value: -8, label: 'Pacific (UTC-8:00)' },
  { value: -7, label: 'Mountain (UTC-7:00)' },
  { value: -6, label: 'Central (UTC-6:00)' },
  { value: -5, label: 'Eastern (UTC-5:00)' },
]

export const FEATURED_TYPES = {
  none: 'none',
  queued: 'queued',
  featured: 'featured',
}
